export const commonStyles = {
  "base": "",
  carousel: {
    imageContainer: "w-full h-[650px] bg-white mb-8",
    dots: "z-[99] flex flex-row gap-5 mt-[-80px] mb-[30px]",
    dot: "w-4 h-4 bg-gray-transparent border-2 border-gray-400 rounded-full cursor-pointer",
    activeDot: "w-4 h-4 bg-gray-300 rounded-full cursor-pointer",
  }
}